import React, { useEffect, useState } from "react";
import { CheckCircle2, XCircle, Clock } from "lucide-react";
import api from "@/lib/api";

export default function ExamHistoryTab({ certId }) {
  const [history, setHistory] = useState(null);

  useEffect(() => {
    api.get(`/certifications/${certId}/exam/history/all`).then((r) => setHistory(r.data));
  }, [certId]);

  if (!history) return <div className="flex justify-center py-16" data-testid="exam-history-loading"><div className="w-8 h-8 border-2 border-accent border-t-transparent rounded-full animate-spin" /></div>;

  if (history.length === 0) {
    return <div className="glass-panel rounded-2xl p-10 text-center text-slate-400" data-testid="exam-history-empty">No mock exam attempts yet — take one from the "Mock Exam" tab.</div>;
  }

  return (
    <div className="space-y-3" data-testid="exam-history-tab">
      {history.map((h) => (
        <div key={h.id} className="glass-panel rounded-xl p-4 flex items-center justify-between" data-testid={`exam-history-row-${h.id}`}>
          <div className="flex items-center gap-3">
            {h.passed ? <CheckCircle2 className="w-5 h-5 text-emerald-400" /> : <XCircle className="w-5 h-5 text-rose-400" />}
            <div>
              <p className="text-sm font-semibold text-white">{h.score}% {h.passed ? "· Passed" : "· Not Passed"}</p>
              <p className="text-xs text-slate-500 flex items-center gap-1 mt-0.5"><Clock className="w-3 h-3" /> {new Date(h.completed_at).toLocaleString()}</p>
            </div>
          </div>
          {h.weak_areas?.length > 0 && (
            <span className="text-xs text-slate-500 max-w-[45%] text-right">Weakest: {h.weak_areas[0].topic}</span>
          )}
        </div>
      ))}
    </div>
  );
}
